import { useBooleanFlagValue } from '@openfeature/react-sdk';

export const RECEIVED_INVOICE_TRANSACTION_FEATURE_KEY = 'transaction_llm_ocr';

export const useReceivedInvoiceTransactionFlag = () =>
  useBooleanFlagValue(RECEIVED_INVOICE_TRANSACTION_FEATURE_KEY, false);
